export default __webpack_public_path__ + "static/media/success.53934332.svg";